// extracted by mini-css-extract-plugin
export default {"navigationDeep2":"n5NDV_n5NDV","navigationDeep3":"XxVzh_XxVzh"};